import {
  ButtonArrowState,
  Modal,
  TertiaryButton,
} from '@huggg/react-components';
import dictionary from 'config/dictionary';
import React, { useState } from 'react';
import styles from './prepaidCard.module.scss';

const PersonalDetailsModal = ({ onClose }) => {
  return (
    <Modal
      title={'Why do we need your personal details?'}
      onClose={onClose}
      className={styles.personalDetailsModal}
    >
      <div>
        <ul className={styles.bulletedList}>
          <li className={styles.listItem}>
            To issue a digital prepaid card we need to perform customer checks,
            similar to when you open a bank account
          </li>
          <li className={styles.listItem}>
            {dictionary.prepaidCards.copy.whyPersonalDetails}
          </li>
          <li className={styles.listItem}>
            No credit checks will be performed and your credit score will be
            unaffected
          </li>
        </ul>
      </div>
      <TertiaryButton
        label={dictionary.prepaidCards.labels.closeThisWindow}
        onClick={onClose}
        arrow={ButtonArrowState.None}
      />
    </Modal>
  );
};

export const PersonalDetailsDialog = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <button
        className={styles.buttonAsLink}
        type="button"
        onClick={() => setShowModal(true)}
      >
        Why do we need your personal details?
      </button>

      {showModal && (
        <PersonalDetailsModal onClose={() => setShowModal(false)} />
      )}
    </div>
  );
};
